import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';


@Component({
    selector: 'app-search-input',
    imports: [FormsModule, ReactiveFormsModule,NgIf,NgClass],
    templateUrl: './search-input.component.html',
    styleUrl: './search-input.component.css',
    standalone: true,
})
export class SearchInputComponent {
  @Input() placeholder: string = '';
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() disabled: boolean = false;
  @Output() fetch_new_list = new EventEmitter<any>();

  value: string = '';
  private searchSubject = new Subject<string>();

  constructor(public route: Router, public ar: ActivatedRoute) {}

  ngOnInit() {
    this.ar.queryParams.subscribe((params:any) => {
      this.value = params['search'] || '';
    });
    this.check_screen_size();
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe(val => {
        this.valueChange.emit(val);
        this.route.navigate([], {
          relativeTo: this.ar,
          queryParams: { search: val || null },
          queryParamsHandling: 'merge',
        });
      });
  }

  onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.value = inputElement.value;
    this.searchSubject.next(this.value);
  }
  clearInput() {
  this.value = '';
  this.fetch_new_list.emit('')
  this.searchSubject.next(this.value);
}

  // Optional ControlValueAccessor support
  control: any;
  onChange: any;
  onTouched: any;

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  is_search_expanded: boolean = false;

  toggle_search_mobile(): void {
    // Only toggle if screen is small (optional check, but good for logic)
    this.is_search_expanded = !this.is_search_expanded;
  }

  // Function to handle blur (optional: close when user clicks away)
  on_blur(): void {
    if (this.value === '') {
      this.is_search_expanded = false;
    }
  }


  // Listen for window resize events to update dynamiclly
  @HostListener('window:resize', ['$event'])
  on_resize(event: any) {
    this.check_screen_size();
  }

  check_screen_size() {
    // 768px matches the Tailwind 'md' breakpoint
    if (window.innerWidth >= 768) {
      this.is_search_expanded = true;  // Big screen (Desktop/Tablet)
    } else {
      this.is_search_expanded = false; // Small screen (Mobile)
    }
  }
}